import Desktop from './Desktop'
import withDevice from '../withDevice'

export default withDevice(Desktop)
